import React from "react";
import Slider from "react-slick";
import etiqueta1 from '../../../images/etiqueta_planes.png';
import Button from "../../elements/buttons/Button";

export default function SimpleSlider() {
  var settings = {
    centerMode: true,
    arrows: false,
    pauseOnHover: false,
    dots: false,
    centerPadding: '0',
    slidesToShow: 1,
    fade: true,
    autoplay: 7000,
    speed: 2000,
    cssEase: 'linear',
    responsive: [
        {
        breakpoint: 768,
        settings: {
            arrows: false,
            dots: false,
            centerMode: true,
            pauseOnHover: false,
            centerPadding: '0',
            autoplay: 7000,
            speed: 2000,
            fade: true,
            cssEase: 'linear',
            slidesToShow: 1
        }
        }
    ]
  };
  return (
      <>
        <section className="HeroPlanes">
                <div className="HeroPlanes__caption">
                    <div className="container">
                        <div className="wrap">
                            <div className="slider__caption">
                                <img src={etiqueta1} />
                                <h2 className="titlesBig">Calidad al mejor precio</h2>
                                <p>Descubre en detalle nuestros planes con todas las features incluidas.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <Slider {...settings}>
                    <div>
                        <section className="HeroPlanes__slider" ></section>
                    </div>
                    <div>
                        <section className="HeroPlanes__slider secondSlider"></section>
                    </div>
                    <div>
                        <section className="HeroPlanes__slider tertiarySlider"></section>
                    </div>
                </Slider>
            
    </section>
    </>
  );
}